import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../components/Modal';

type APIDeleteKeyModalProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isHidden?: boolean;
};

export const APIDeleteKeyModal: React.FC<APIDeleteKeyModalProps> = ({
  onCancel,
  onConfirm,
  isHidden,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isBig
      confirmText={t(
        `features:collaboration:api-management:keyDeletion:deleteKeyModal:confirmText`,
      )}
      heading={t(
        `features:collaboration:api-management:keyDeletion:deleteKeyModal:heading`,
      )}
      headingAlign="left"
      isCloseIconHidden={false}
      isConfirmButtonAlignedRight={false}
      isConfirmButtonDisabled={false}
      isHidden={isHidden}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <span>
        {t(
          `features:collaboration:api-management:keyDeletion:deleteKeyModal:description`,
        )}
      </span>
    </Modal>
  );
};
